import React from "react";

const HolographicNail = () => {
  return (
    <div className="blogWhat-content">
      <h5>8. Holographic Nails: Light Up Your Look</h5>
      <p>
        Holographic nails add a multi-dimensional, futuristic touch to your
        manicure. Whether you choose holographic powders, glitter-infused gels,
        or reflective topcoats, these nails catch the light beautifully.
        Available in cool-toned silvers, blues, and vibrant rainbow shades,
        holographic nails create an eye-catching and glamorous effect.
      </p>
    </div>
  );
};

export default HolographicNail;
